import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "/bitrise/src/node_modules/core-js/modules/es6.array.iterator.js";
import "/bitrise/src/node_modules/core-js/modules/es6.promise.js";
import "/bitrise/src/node_modules/core-js/modules/es6.object.assign.js";
import "/bitrise/src/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ja';
import "./styles/element-variables.scss";
import '@/styles/index.scss'; // global css

import firebase from 'firebase/app'; // firebase

require('firebase/auth');

import 'firebase/storage';
import App from "./App";
import store from "./store";
import router from "./router";
import "./icons"; // icon

import "./permission"; // permission control

import "./utils/error-log"; // error log

import * as filters from "./filters"; // global filters

import VueApollo from 'vue-apollo';
import { apolloClient } from '@/apollo/apolloClient';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import '@jledentu/vue-finder/dist/vue-finder.css';
import device from 'vue-device-detector';
import VueLoadmore from 'vuejs-loadmore';
import linkify from 'vue-linkify';
Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_URL,
  integrations: [new Integrations.Vue({
    Vue: Vue,
    attachProps: true
  })]
});
Vue.use(VueApollo);
Vue.use(device);
Vue.use(VueLoadmore);
Vue.directive('linkify', linkify);
var apolloProvider = new VueApollo({
  defaultClient: apolloClient
});
Vue.use(Element, {
  size: Cookies.get('size') || 'medium',
  // set element-ui default size
  locale: locale
}); // register global utility filters

Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
Vue.filter('truncate', function (value, length) {
  if (value) {
    var lengthTest = length ? parseInt(length, 10) : 20;

    if (value.length <= length) {
      return value;
    }

    return value.substring(0, lengthTest) + '...';
  }
});
new Vue({
  created: function created() {
    var environmentVariable = [process.env.NODE_ENV === 'production' ? 'VUE_APP_SENTRY_URL' : null, 'VUE_APP_FIREBASE_CONFIG_API_KEY', 'VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN', 'VUE_APP_FIREBASE_CONFIG_DATABASE_URL', 'VUE_APP_FIREBASE_CONFIG_PROJECT_ID', 'VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET', 'VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID', 'VUE_APP_FIREBASE_CONFIG_APP_ID', 'VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID', 'VUE_APP_HASURA_URI', 'VUE_APP_CRYPT_KEY', 'VUE_APP_CRYPT_IV', 'VUE_APP_BASE_API', 'NODE_ENV'];
    var checkEnvironmentVariable = environmentVariable.filter(function (environment) {
      return !process.env[environment] && environment;
    });

    if (checkEnvironmentVariable.length !== 0) {
      console.log(checkEnvironmentVariable);
      this.$message({
        message: 'ビルド設定を確認してください。',
        type: 'error',
        duration: 50000
      });
    }
  }
});
Vue.config.productionTip = false; // firebaseSDK

var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_CONFIG_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_CONFIG_MEASUREMENT_ID
}; // Initialize Firebase

firebase.initializeApp(firebaseConfig);
firebase.auth().onAuthStateChanged(
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(user) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!user) {
              _context.next = 4;
              break;
            }

            store.dispatch('user/setFirebaseUser', user);
            _context.next = 7;
            break;

          case 4:
            store.dispatch('user/setFirebaseUser', []);
            _context.next = 7;
            return firebase.auth().signOut();

          case 7:
            new Vue({
              el: '#app',
              router: router,
              store: store,
              apolloProvider: apolloProvider,
              render: function render(h) {
                return h(App);
              }
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());